module.exports.COLORS = {
  YELLOW: 'FFFF00',
  RED: 'FF0000',
  GREEN: '50C878',
  BLUE: '4E9FE5',
  ORANGE: 'FBCFB1'
}

// Determine alert status based on the following MOS threshold
// overstock (>12 MOS)
// Stocked to plan (between 12 and 6)
// Understocked ( between 6 and 3 MOS)
// Stock out ( less than 3 MoS)
module.exports.getAlertStatus = (mos) => {
  if (mos > 12) return 'Overstock'
  if (mos >= 6) return 'Stocked to plan'
  if (mos >= 3) return 'Understocked'
  return 'Stock out'
}
